// @flow
/**
 * User: Mike Chung
 * Date: 20/1/2018
 * Time: 5:10 PM
 */

import type {SsoUserQueryActionCollection, SsoUserQueryFailedAction} from "../actions/sso/ssoUserQueryAction";
import SsoUser from "../model/sso/SsoUser";
import type {SsoUserQueryCriteria} from "../model/sso/SsoUserQueryCriteria";
import type {ReducedError} from "../types/ErrorTypes";
import * as _ from 'lodash';
import type {SsoUserActivateUserSuccessAction} from "../actions/sso/ssoUserAction";

export type SsoUserQueryState = {

    isLoading: boolean,
    ssoUsers: Array<SsoUser>,
    totalResult: number,
    criteria: SsoUserQueryCriteria,
    error?: any
}

const INITIAL_STATE: SsoUserQueryState = {
    isLoading: false,
    ssoUsers: [],
    totalResult: -1,
    criteria: {
        email: undefined,
        firstName: undefined,
        lastName: undefined,
        page: 1,
        pageItem: 20
    }
};

let reduceError = function (state: SsoUserQueryState, action: SsoUserQueryFailedAction) {

    let reducedError: ReducedError = {
        message: _.get(action, "error.message", "Please input at least 1 search criteria!")
    };

    return {
        ...state,
        isLoading: false,
        ssoUsers: [],
        error: reducedError
    };
};

export default function reducer(state: SsoUserQueryState = INITIAL_STATE, action: SsoUserQueryActionCollection | SsoUserActivateUserSuccessAction) {

    switch (action.type) {
        case "sso/QUERY_START_ACTION":
            return {
                ...state,
                isLoading: true,
                criteria: action.criteria,
                error: undefined
            };
        case "sso/QUERY_SUCCESS_ACTION":

            return {
                ...state,
                isLoading: false,
                totalResult: action.totalResult,
                ssoUsers: [].concat(action.ssoUsers),
                error: undefined
            };
        case "sso/QUERY_FAILED_ACTION":

            return reduceError(state, action);
        case "sso/ACTIVATE_USER_SUCCESS_ACTION":
            const activateUserAction = (action: SsoUserActivateUserSuccessAction);
            let index = _.findIndex(state.ssoUsers, (e:SsoUser) => e.ssoUid === activateUserAction.ssoUid);
            let targetUser = state.ssoUsers[index];
            targetUser.status = "active";
            let result = [].concat(state.ssoUsers);
            result.splice(index, 1, targetUser);
            return {
                ...state,
                ssoUsers: result
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/SsoUserQueryReducer.js